import React, { useState } from 'react';
import { colors as theme } from '../theme';

const STORAGE_KEY = 'cipher_onboarded_v1';

export const shouldShowOnboarding = () => !localStorage.getItem(STORAGE_KEY);
export const markOnboardingDone = () => localStorage.setItem(STORAGE_KEY, '1');

const steps = [
  {
    emoji: '👋',
    title: 'Welcome to Cipher',
    body: 'Your training program is set up and ready to go. Your coach has built it specifically for you — all you need to do is show up and log your sets.',
  },
  {
    emoji: '📝',
    title: 'How to log a set',
    body: 'Each exercise shows your target sets and reps. For each set, enter the weight you lifted and your reps: the set ticks itself off. Did the exercise without logging numbers? Tap Mark done.',
  },
  {
    emoji: '✅',
    title: 'Finishing your session',
    body: 'Once you\'ve worked through your exercises, tap the green Complete Day button at the bottom of the screen. This saves your session and keeps your progress on track.',
  },
];

const colors = {
  bg: 'rgba(10,14,39,0.96)',
  surface: theme.surface1,
  border: 'rgba(42,53,98,0.8)',
  text: theme.text,
  textMuted: theme.textMuted,
  accent: theme.gold,
  success: theme.success,
};

const OnboardingModal = ({ onDone }) => {
  const [step, setStep] = useState(0);
  const current = steps[step];
  const isLast = step === steps.length - 1;

  const handleNext = () => {
    if (isLast) {
      markOnboardingDone();
      onDone();
    } else {
      setStep(s => s + 1);
    }
  };

  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 1000,
      backgroundColor: colors.bg,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px',
    }}>
      <div style={{
        backgroundColor: colors.surface,
        border: `1px solid ${colors.border}`,
        borderRadius: '20px',
        padding: '36px 28px',
        maxWidth: '380px',
        width: '100%',
        textAlign: 'center',
      }}>
        {/* Step dots */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: '6px', marginBottom: '28px' }}>
          {steps.map((_, i) => (
            <div key={i} style={{
              width: i === step ? '20px' : '6px',
              height: '6px',
              borderRadius: '4px',
              backgroundColor: i === step ? colors.accent : colors.border,
              transition: 'all 0.25s ease',
            }} />
          ))}
        </div>

        {/* Emoji */}
        <div style={{ fontSize: '48px', marginBottom: '20px', lineHeight: 1 }}>
          {current.emoji}
        </div>

        {/* Title */}
        <h2 style={{
          color: colors.text, fontSize: '20px', fontWeight: 700,
          margin: '0 0 14px', lineHeight: 1.3,
        }}>
          {current.title}
        </h2>

        {/* Body */}
        <p style={{
          color: colors.textMuted, fontSize: '15px', lineHeight: 1.6,
          margin: '0 0 32px',
        }}>
          {current.body}
        </p>

        {/* CTA */}
        <button
          onClick={handleNext}
          style={{
            width: '100%',
            padding: '16px',
            backgroundColor: isLast ? colors.success : colors.accent,
            border: 'none',
            borderRadius: '14px',
            color: isLast ? theme.text : theme.bg,
            fontSize: '16px',
            fontWeight: 700,
            cursor: 'pointer',
          }}
        >
          {isLast ? "Let's go" : 'Next'}
        </button>

        {/* Skip */}
        {!isLast && (
          <button
            onClick={() => { markOnboardingDone(); onDone(); }}
            style={{
              marginTop: '14px',
              background: 'none',
              border: 'none',
              color: colors.textMuted,
              fontSize: '13px',
              cursor: 'pointer',
              padding: '4px',
            }}
          >
            Skip
          </button>
        )}
      </div>
    </div>
  );
};

export default OnboardingModal;
